import { values as LIBELLES } from '../../../contexts/LanguageContext'
import { choisirTexte, FORME_TU, FORME_VOUS } from '../../../utils/formeAdresse'

/* ⛔ BILAN SOFT SKILLS, « POUR LINKEDIN » : LE TEXTE DU POST (07/10/2026,
   v3, decision de Nawal ; MAQUETTE, rien de branche).

   Un post pret a copier, a la PREMIERE personne, sobre et fier, sur le
   modele valide par Nawal (dictionnaire, `postLinkedIn`) : le titre du plan,
   les 3 atouts, « Prochaine étape », puis deux mots-cles. Aucun texte
   genere : un gabarit fixe, rempli avec les noms d'usage des fiches.

   LES ATOUTS A LA PREMIERE PERSONNE, par une regle FIXE (`premierePersonne`),
   verifiee sur les 18 noms d'usage (tests) :
     - premiere lettre en minuscule (« Organiser » -> « organiser ») ;
     - possessifs : son / sa / ses -> mon / ma / mes ;
     - pronoms reflechis : se -> me, s' -> m' (devant une voyelle ou un h),
       soi -> moi.
   ⚠️ La regle ne connait pas le genre : « rester constructif » garde
   l'accord masculin (a trancher par Nawal). */

/* tu ou vous : le mecanisme publie ; la forme vient du public du contenu */
const forme = (contenu) => (contenu?.public === 'professionnel' ? FORME_VOUS : FORME_TU)
const libelle = (cle, langue, f) => choisirTexte(LIBELLES?.bilanSoftSkills?.[cle], langue, f) ?? LIBELLES?.bilanSoftSkills?.[cle]?.fr ?? ''

/* un mot entier, sans tenir compte de la casse ; `[’']` : les deux
   apostrophes */
const APOS = "[’']"
export const premierePersonne = (nomUsage) => {
  let t = String(nomUsage || '').trim()
  if (!t) return ''
  t = t.charAt(0).toLocaleLowerCase('fr') + t.slice(1)
  const remplacer = (motif, par) => { t = t.replace(new RegExp('(^|[\\s(])' + motif + '(?=$|[\\s,.;:!?)])', 'g'), (m, avant) => avant + par) }
  remplacer('son', 'mon')
  remplacer('sa', 'ma')
  remplacer('ses', 'mes')
  remplacer('se', 'me')
  remplacer('soi', 'moi')
  t = t.replace(new RegExp('(^|[\\s(])s(' + APOS + ')(?=[aeiouyhàâäéèêëîïôöûüœ])', 'gi'), (m, avant, apostrophe) => avant + 'm' + apostrophe)
  return t
}

/* « a, b et c » */
const enumerer = (mots, et) => (mots.length < 2 ? mots.join('') : mots.slice(0, -1).join(', ') + ' ' + et + ' ' + mots[mots.length - 1])

/* sans titre du plan (pas dans les donnees de l'apprenant), le gabarit qui
   ne cite pas de parcours : aucune valeur inventee */
export const textePostLinkedIn = ({ nomParcours, contenu, langue = 'fr' }) => {
  const f = forme(contenu)
  const atouts = (contenu?.atouts || []).map((a) => premierePersonne(a.nomUsage))
  const parcours = String(nomParcours || '').trim()
  const corps = libelle(parcours ? 'postLinkedIn' : 'postLinkedInSansParcours', langue, f)
    .replace('{parcours}', parcours)
    .replace('{atouts}', enumerer(atouts, libelle('postEt', langue, f)))
  return corps + '\n\n' + libelle('postMotsCles', langue, f)
}

/* pour la rubrique « Compétences » du profil : le nom d'usage, tel quel */
export const competencesProfil = (contenu) => (contenu?.atouts || []).map((a) => a.nomUsage)

/* le fichier texte : le post, puis, a part, les 3 competences pour le profil */
export const texteFichierPost = ({ nomParcours, contenu, langue = 'fr' }) => {
  return textePostLinkedIn({ nomParcours, contenu, langue }) + '\n\n\n'
    + libelle('competencesProfil', langue, forme(contenu)) + '\n'
    + competencesProfil(contenu).join('\n') + '\n'
}
